import React from 'react';
import PropTypes from 'prop-types';
import './MyProfile.scss';
import { withTranslation } from 'react-i18next';

const MyProfile = ({ t }) => {
  return (
    <div className="MyProfile">
    MyProfile Component
    </div>
  );
};
export default withTranslation()(MyProfile);